/**
 * Open link with a specific URL.
 * @param {string} url URL.
 */
export function openLink(url) {
  // Use this method instead of `window.open` to make this download work on safari.
  // `window.open` is unsecured method, so do not use it.
  // Reference: https://stackoverflow.com/a/63170977
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  a.target = '_blank';
  a.href = url;
  a.click();
  document.body.removeChild(a);
}
